<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Engineering Science"
                   :links="[{title:'Home', url:'/'},{title:'Engineering Science'}]"></page-header>

      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="1"></sidebar>
        </section>
        <section class="content">
          <div class="flex justify-center">
            <div class="flex flex-col space-y-1 items-center">
              <img class="shadow-lg" :src="`/static/images/science/faculty/ansari_us.jpg`"
                   alt="Head of Department of Engineering Science">
              <h3 class="text-lg font-medium text-gray-800 leading-tight">Prof. Ansari U.S. </h3>
              <h4 class="text-gray-500 font-medium leading-tight">Head of the Department</h4>
            </div>
          </div>
          <blockquote class="mt-3 about-message">
            <p>First Year Engineering plays a key role in development of the students to be a prospective engineer. The
              department nurtures and molds the students to enter in the rapid fast changing pragmatic world yet
              maintaining the sensitivity in them. The teaching-learning methodology used by staff boosts the students
              thinking potential and lifts their critical analyzing skills. As most of the students come from the
              diversified social environment it becomes a need for the department that they are mentored by the staff
              with whom they can share their thoughts, expectations, express themselves and would feel comfortable away
              from home. For overall development of students we use feedback system of each stack holders which includes
              tutor meetings in every week, informing the progress of students to parents and corrective actions for
              aspects where improvement is required. We have total 09 faculties in applied sciences apart of support
              from department faculty. Hence, our self-motivated staff wholly dedicated to the first year department, do
              their best and try to make the subjects simple and interesting.
              Apart from curriculum, extra curriculum activities are arranged regularly like debate, extempore, expert
              lecture, field visit etc. to create multifaceted talent in students. In concluding we assure a healthy
              environment to develop technical skills among students </p>
            <signature name="Prof. Ansari U.S." designation="Head of the Department"></signature>
          </blockquote>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/science/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import Signature from "@/components/Signature";

export default {
  name: "About",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    Signature,
  },

}
</script>
<style lang="scss" scoped>
</style>
